import Card from "../Card";
import Section from "../Section";
import Button from "../Button";
import { NavLink } from "react-router-dom";
function ProjectsSt() {
  const projects = [
    {
      id: 1,
      title: "Site Teach-me",
      desc: "Un site d'apprentissage et mentoring en ligne responsive conçu avec React et Tailwind.",
      image: `${process.env.PUBLIC_URL}/assets/images/red-mouse.png`,
    },
    {
      id: 2,
      title: "Campagne Tiktok",
      desc: "Stratégie sociale augmentant l’engagement de 40%, pour un compte d'un artist Gospel",
      image: `${process.env.PUBLIC_URL}/assets/images/insta.png`,
    },
    {
      id: 3,
      title: "Audit Système",
      desc: "Optimisation d’un réseau d’entreprise.",
      image: `${process.env.PUBLIC_URL}/assets/images/cons.png`,
    },
  ];

  return (
    <Section>
      {" "}
      <h2 className="text-3xl font-bold text-center mb-8 text-blue-600">
        <strong className=" text-orange-400"> Mes </strong>Projets
      </h2>{" "}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {" "}
        {projects.map((project) => (
          <Card
            key={project.id}
            title={project.title}
            description={project.desc}
            image={project.image}
          />
        ))}{" "}
      </div>{" "}
      <NavLink to="projects">
        <div className=" mt-6 md:text-start text-center">
          <Button text="Voir plus" color="bg-blue-600" />{" "}
        </div>
      </NavLink>
    </Section>
  );
}
export default ProjectsSt;
